import React, { useContext } from 'react'
import { QuizContext } from '@health-zelas/quiz'
import { Button, Container, Grid, Heading, Paragraph } from '@health-zelas/delta'

import Step from "../../components/Step"
import ProgressBar from '../../components/ProgressBar'

export function RequestQuotationError(){
  const { getFieldByName } = useContext(QuizContext)
  const cnpjActive = getFieldByName('o_cnpj_esta_ativo_ha_mais_de_6_meses____simulador')
  const state = getFieldByName('estado___uf')
  const isSp = state === 'SP'

  const isActiveCnpjAndFromSP = cnpjActive === 'Sim' && isSp

  const shouldRenderQualicorpInfos = cnpjActive !== 'Sim' || (cnpjActive === 'Sim' && !isSp)

  return (
    <Step>
      <Container css={{ paddingBottom: '$lg' }}>
        <Grid>
          <Grid.Item colSpans={{ sm: 12, md: 6, lg: 5 }}>
            <div>
              <ProgressBar title="Dados pessoais" fill={isActiveCnpjAndFromSP ? 2 : 3} />

              {isActiveCnpjAndFromSP && (
                <>
                  <Heading
                    as="h1"
                    size="lg"
                    weight="bold"
                    css={{
                      marginBottom: '$xxs'
                    }}
                  >
                    Primeiro, complete suas informações
                  </Heading>
                  <Paragraph
                    size="lg"
                    color="$neutralDark"
                    lineHeight="distant"
                    css={{
                      marginBottom: '$md'
                    }}
                  >
                    Assim, após a simulação, entraremos em contato com você para tirar dúvidas e conversar mais sobre os planos.
                  </Paragraph>
                </>
              )}

              {shouldRenderQualicorpInfos && (
                <>
                  <Heading
                    as="h1"
                    size="lg"
                    weight="bold"
                    css={{
                      marginBottom: '$xxs'
                    }}
                  >
                    Vamos te encaminhar para a Qualicorp, ok?
                  </Heading>
                  <Paragraph
                    size="lg"
                    color="$neutralDark"
                    lineHeight="distant"
                    css={{
                      marginBottom: '$md'
                    }}
                  >
                    É a nossa parceira que vai mostrar os planos disponíveis pra você.
                  </Paragraph>
                  <Heading
                    as="h3"
                    weight="bold"
                    css={{
                      marginBottom: '$xxxs'
                    }}
                  >
                    Por quê?
                  </Heading>
                  <Paragraph
                    lineHeight="distant"
                    color="$neutralDark"
                  >
                    {cnpjActive === 'Não' || (cnpjActive === 'Sim' && !isSp)
                      ? 'A Zelas Saúde trabalha somente com CNPJ de São Paulo e que esteja ativo há pelo menos 6 meses. Para o seu caso, a Qualicorp pode te ajudar!'
                      : 'A Zelas Saúde trabalha somente com planos contratados por CNPJ. No caso de contratação por pessoa física (CPF), a Qualicorp pode te ajudar!'
                    }
                  </Paragraph>
                </>
              )}
            </div>
          </Grid.Item>

          <Grid.Item colStarts={{ md: 7 }} colEnds={{ md: 13 }}>
            <div>
              <Heading
                size="md"
                lineHeight="md"
                weight="bold"
                css={{
                  color: '$criticalMedium',
                  marginBottom: '$xs',
                }}
              >
                Não foi possível finalizar a sua simulação
              </Heading>

              <Paragraph
                size={{
                  "@initial": "md",
                  "@md": "lg"
                }}
                css={{
                  color: '$neutralDark',
                }}
              >
                Precisamos da sua autorização para compartilhar seus dados com parceiros. Só assim você receberá orçamentos e poderá comparar planos entre diferentes corretoras.

                <Paragraph
                  as="strong"
                  weight="bold"
                  css={{
                    display: 'block',
                    marginTop: '$xs',
                    marginBottom: '$xs'
                  }}
                >
                  Volte para a tela anterior e autorize o compartilhamento de dados para prosseguir.
                </Paragraph>
              </Paragraph>

              <Button
                type="button"
                onClick={() => window.history.back()}
                css={{
                  justifySelf: 'start'
                }}
              >
                Voltar
              </Button>
            </div>
          </Grid.Item>
        </Grid>
      </Container>
    </Step>
  )
}
